// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2tC3x","tab":"ProcedureTabs_tab__2b0xh"};